import handleTrailingSlash from '../../../../../../../shared/base/utils/handleTrailingSlash';

/**
 * Find a news banner for the current page and check if it should be shown.
 *
 * @param {allContentfulComponentNewsBanner} allNewsBanners
 * @param {String} pathname
 * @param {String} utmCampaign
 * @returns {ContentfulComponentNewsBanner}
 */
const findCurrentNewsBanner = ({ allNewsBanners, pathname, utmCampaign }) => {
  // try and find first a banner with matching campaignName and page
  const bannerWithCampaign = allNewsBanners.find(
    ({ campaignName, masterHideBanner, pagesWithBanner }) =>
      campaignName === utmCampaign &&
      !masterHideBanner &&
      pagesWithBanner?.some(({ slug }) => handleTrailingSlash(slug) === pathname),
  );

  if (bannerWithCampaign) return bannerWithCampaign;

  // fallback to a banner with just a page match and no masterHideBanner
  return allNewsBanners.find(
    ({ masterHideBanner, pagesWithBanner }) =>
      !masterHideBanner && pagesWithBanner?.some(({ slug }) => handleTrailingSlash(slug) === pathname),
  );
};

export default findCurrentNewsBanner;
